import KoioteTankCanvasQuesos from "./KoioteTankCanvasQuesos.vue";
import KoioteTankCanvasQuesosProperties from "./KoioteTankCanvasQuesosProperties.vue";
import KoioteTankCanvasQuesosProperty from "./default.json";

export default {
  install(Vue) {
    Vue.component(KoioteTankCanvasQuesos.name, KoioteTankCanvasQuesos);
    Vue.component(KoioteTankCanvasQuesosProperties.name, KoioteTankCanvasQuesosProperties);
    Vue.prototype.$KoioteTankCanvasQuesosProperty = KoioteTankCanvasQuesosProperty;
  },
};
